
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import WidgetTools from "../widgetTools";
import { removeWidget } from "src/redux/supervisorSlice";
import MonitorWSService from 'src/services/monitorwsservice';
import DialerCard from './dialercard';

import { Row } from 'react-bootstrap';

function DialersStatus(props) {
    const { t } = useTranslation();
    const [dialers, setDialers] = useState([]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/dialersstatus", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("dialersstatus");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {

        if (props.connected) {
            MonitorWSService.stompClient.send("/app/subscribe/dialersstatus", {}, JSON.stringify({
                token: props.token
            }));
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/dialersstatus/`, updateState, { id: "dialersstatus" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const updateState = (groups) => {
        if (!document.hidden) {
            let data = JSON.parse(groups.body);
            setDialers(data);
        }
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="dialersstatuswidget">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("bell-on")} /> {t("dialersstatus")} <span className="badge badge-light-primary fs-base">{dialers.length}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={null}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px" }}>
                <Row>
                    {
                        dialers.map(v => {
                            return <DialerCard key={v.extension} dialer={v}></DialerCard>
                        })
                    }
                </Row>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        connected: state.parameters.connected
    };
};

export default connect(mapStateToProps, { removeWidget })(DialersStatus);